<template>
    <div id="tasksMakeMoney">
        <Headers :headersText='headersText'></Headers>
        <div class="boxPadding">
            <div class="explain">
                <div class="text">
                    <div class="title">(1)快速任务</div>
                    <div class="content">&emsp;快速任务是用户最常点击和完成效率最高的任务类型，有任务时您可直接点击并按照步骤提示操作完成；您也可以关注任务预告，以便在任务发放时能及时抢到任务，它的操作步骤简单、花费时间短，适合在您短暂的闲暇时间内完成</div>
                    <div class="title">(2)回调任务</div>
                    <div class="content">&emsp;回调任务与快速任务操作步骤相同，不同点在于，回调任务有很小的几率在奖励到账时会有延迟</div>
                    <div class="title">(3)联盟任务</div>                
                    <div class="content">&emsp;联盟任务是钱大师与合作伙伴发放出来的任务，它的操作步骤也较简单，按照步骤提示完成即可，因为需要审核，故奖励到账时间较快速任务会有所延迟</div>
                    <div class="title">(4)高额任务</div>
                    <div class="content">&emsp;高额任务的操作步骤比快速任务多一些，多数任务都需要进行截图和审核，但奖励丰厚，高额任务适合在您有充足的空闲时间时来完成</div>
                    <div class="title">(5)游戏任务</div>                
                    <div class="content">&emsp;游戏任务需要您注册后持续试玩达到一定标准，每个标准都有不同的奖励可赚取，花费时间较多，您可调整自己的时间完成任务</div>
                    <div class="title">(6)评论任务</div> 
                    <div class="content">&emsp;评论任务暂时停止发放</div>                
                </div>

                <img src="../../assets/images/img_50.png" alt="" id="bgs">
            </div>
        </div>
    </div>
</template>

<script>
    import Headers from '../../components/headers.vue'
    export default {
        components:{
            Headers
        },
        data() {
            return {
                headersText:'做任务赚钱',
            }
        },
        methods: {
            
        },
    }
</script>

<style lang="less" scoped>
    #tasksMakeMoney{
        .boxPadding{
            padding: 15px;
            .explain{
                width: 345px;
                background: #FFFFFF;
                border-radius: 5px;
                border: 1px solid #DEDEDE;
                position: relative;
                .text{
                    margin: 15px;
                    color: #111111;
                    font-size: 13px;
                    line-height: 18px;
                    .title{
                        font-weight: bold;
                        &:not(:first-of-type){
                            margin-top: 15px;
                        }
                    }
                }
                #bgs{
                    width: 216px;
                    height: 158px;
                    position: absolute;
                    right: 20px;
                    bottom: 20px;
                }
            }
        }
    }
</style>